document.addEventListener("DOMContentLoaded", function() {
    var tabs = document.querySelectorAll('ul.shopify-tabs > li');
    
    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            var tab_id = tab.getAttribute('data-tab');

            tab.parentNode.querySelectorAll('li').forEach(function(li) {
                li.classList.remove('current');
            });

            document.querySelectorAll('.shopify-tab-content').forEach(function(content) {
                content.classList.remove('current');
            });

            tab.classList.add('current');
            document.getElementById('tab-' + tab_id).classList.add('current');
        });
    });
});
